import { useState } from "react";

import Input from "Components/Global/Form/Input";

import * as S from "./styles";

export const DigitSeparated = ({ name, digits, gridArea, margin, ...rest }) => {
  const [value, setValue] = useState(Array(digits).fill(0));

  const handleChange = (e) => {
    setValue((prev) => {
      const { name, value } = e.target;
      const newValue = [...prev];
      newValue[name] = value ? parseInt(value) : 0;
      const nextInput = document.querySelector(
        `input[name="${parseInt(name) + 1}"]`,
      );
      if (nextInput && value !== "") {
        nextInput.focus();
      }
      return newValue.join("");
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && e.target.value === "") {
      const previousInput = document.querySelector(
        `input[name="${parseInt(e.target.name) - 1}"]`,
      );
      if (previousInput) {
        previousInput.focus();
      }
    }
  };

  const handlePaste = (e) => {
    var clipboardData, pastedData;

    e.stopPropagation();
    e.preventDefault();

    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    const numbersPasted = pastedData.replace(/\D/g, "").split("");

    const getInput = (name) => {
      return document.querySelector(`input[name="${name}"]`);
    };

    if (!numbersPasted.length) return;

    for (let i = 0; i < digits; i++) {
      if (getInput(i)) {
        getInput(i).value = numbersPasted[i];
      }
    }

    setValue(
      Array(digits)
        .fill(0)
        .map((_, index) => {
          return numbersPasted[index] || 0;
        })
        .join(""),
    );

    getInput(numbersPasted.length)
      ? getInput(numbersPasted.length).focus()
      : null;
  };

  return (
    <>
      <S.InputWrapper digits={digits} gridArea={gridArea} margin={margin}>
        {Array(digits)
          .fill(0)
          .map((_, index) => {
            return (
              <S.Input
                pattern="[0-9]"
                required
                placeholder="0"
                {...rest}
                maxLength="1"
                key={index}
                name={index}
                type="number"
                inputmode="numeric"
                onChange={(e) => {
                  if (e.target.value.length > 1) {
                    e.target.value = e.target.value.slice(0, 1);
                  }

                  handleChange(e);
                  rest?.onChange && rest.onChange(e);
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  rest?.onKeyDown && rest.onKeyDown(encodeURI);
                }}
                onPaste={handlePaste}
              />
            );
          })}
      </S.InputWrapper>
      <S.Wrapper>
        <Input name={name} value={value} />
      </S.Wrapper>
    </>
  );
};
